// extracted by mini-css-extract-plugin
export default {"wrapper":"Bots_wrapper__34jXT","bots_container":"Bots_bots_container__+or36","bots_content":"Bots_bots_content__mBou+","items":"Bots_items__prIpQ"};